(ns frontend.view.components.module-selector
  (:require [common.localization :as loc]
            [ui.components.input.checkbox :as checkbox]))

(defn view [{:keys [label control-id value values edit? on-change]}]
  [:div
   {:class "flex flex-col gap-4"}
   [:label
    {:class "text-bold"}
    label]
   [:div
    [:div
     {:class-name (str "flex flex-col gap-3 "
                       (when-not edit? ""))}
     (for [val values]
       ^{:key (str control-id "-checkbox-" val)}
        [:label 
         {:class "flex gap-3 cursor-pointer"}
         [checkbox/view
          {:value     (contains? value val)
           :disabled  (not edit?)
           :on-change (partial on-change val)}]
         [:span (loc/tr val)]]
       )]]])
